import { AdminRole } from "@/types";
import {
  PermissionAction,
  PermissionResource,
  permissionsMatrix,
} from "@/utils";
import { useGetIdentity } from "react-admin";

export const useAccess = () => {
  const { identity } = useGetIdentity();

  const role = identity?.role as AdminRole | undefined;

  const hasPermission = (
    action: PermissionAction,
    allowedActions: PermissionAction[]
  ) => {
    if (allowedActions.includes("*")) return true;
    if (!allowedActions.includes(action)) return false;
    return true;
  };

  const act = (resource: PermissionResource, action: PermissionAction) => {
    if (!role) return false;

    const allowedActions = permissionsMatrix[role][resource];
    return hasPermission(action, allowedActions);
  };

  return {
    canView: (resource: PermissionResource) => act(resource, "view"),
    canCreate: (resource: PermissionResource) => act(resource, "create"),
    canEdit: (resource: PermissionResource) => act(resource, "edit"),
    canDelete: (resource: PermissionResource) => act(resource, "delete"),
  };
};
